export const AFE_CHECKLIST = [
  {
    key: "a",
    question:
      "a) Is the array frame an extraneous-conductive-part as defined in BS 7671?",
    instruction: "Array frame equipotential bonding",
    details:
      "Connect to protective earthing system as main protective bonding (Section 544 of BS 7671)",
  },
  {
    key: "b",
    question:
      "b) Is the array frame an exposed-conductive-part as defined in BS 7671?",
    instruction: "Array frame earthing",
    details:
      "Connect to protective earting via a protective earthing conductor or circuit protective conductor (Section 543 of BS 7671)",
  },
  {
    key: "c",
    question:
      "c) Is lightning protection required, or is the array adjacent to a lightning protection system?",
    instruction: "Array frame earthing for lightning protection",
    details: "Connect to Earth according to BS EN 62305",
  },
  {
    key: "d",
    question: "d) Neither a), b), nor c) apply",
    instruction: "Array frame functional earthing",
    details:
      "Connect to Earth where required, for example, according to panel, inverter or DC power optimizer manufacturer's instructions, or as specified by the system designer (Chapter 54 and section 444 of BS 7671)",
  },
];
